import axios from "axios";
import { useEffect, useState } from "react";

const useVercelMeta = () => {
    const [metaData, setMetaData] = useState<{ country?: string; loaded: boolean }>({ loaded: false });

    const fetchTimeZoneData = async () => {
        try {
            const response = await axios.get("/api/v1/metaData");
            const countryIso = response.data.countryIso;
            if (countryIso && countryIso !== "Unknown") {
                setMetaData({ country: countryIso, loaded: true });
            } else {
                setMetaData({ loaded: true });
            }
        } catch (error) {
            console.error("Error fetching timezone data:", error);
            setMetaData({ loaded: true });
        }
    };

    useEffect(() => {
        fetchTimeZoneData();
    }, []);

    return metaData;
};

export default useVercelMeta;
